import { TerminalPOSService } from "services";
import { ResponseExceptionHandlerHelper, WarningException } from "utils";

export const TerminalPOSManager = (() => {
    const { handleException } = ResponseExceptionHandlerHelper();
    const buscarPorId = (Id, esLookup, requestTracker) => {
        return TerminalPOSService.buscarPorId(Id, esLookup, requestTracker).then(
            (res) => {
                if (!res.Success) {
                    handleException(res);
                }
                return res.Data;
            }
        );
    };

    const listado = (where) => {
        return TerminalPOSService.listado(where).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res;
        });
    };

    const crear = (terminal) => {
        return validar(terminal).then(() => TerminalPOSService.crear(terminal).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res.Data;
        })
        );
    };

    const actualizar = (terminal) => {
        return validar(terminal).then(() => TerminalPOSService.actualizar({
            ...terminal,
            Files: terminal.Img,
        }).then((res) => {
            if (!res.Success) {
                handleException(res);
            }
            return res.Data;
        })
        );
    };

    const validar = (terminal) => {
        return new Promise((res) => res(terminal)).then((terminal) => {
            let requiredFields = [];
            if (!terminal.NombreComercial) {
                requiredFields.push("Nombre Comercial");
            }

            if (!terminal.Direccion) {
                requiredFields.push("Dirección");
            }

            if (!terminal.Telefono) {
                requiredFields.push("Teléfono");
            }

            if (requiredFields.length > 0) {
                throw new WarningException(
                    `Los siguientes campos son requeridos: ${requiredFields.join(", ")}.`
                );
            }
        });
    };

    return {
        buscarPorId,
        listado,
        crear,
        actualizar,
    };
})();
